import React, { useEffect, useState } from 'react'
import Input from '../Input/Input'
import Select from '../Input/Select'
import Button from '../Button'

import "./styles.scss"
import { showToast, startLoading, stopLoading } from '../../services/common-service'
import BlipPortalToastTypes from '../../constants/blip-portal-toast-types'

import { IframeMessageProxy } from 'iframe-message-proxy'
import IMPContainer from '../../constants/iframe-message-proxy-container';

import { v4 as uuid } from 'uuid';
import ObjectListItem from './ObjectListItem'
import FieldItem from './FieldItem'

export default function ModalItem({
    opened,
    setOpened,
    resource,
    getResource,
    setItems
}) {
    const [isNew, setIsNew] = useState(true)
    const [data, setData] = useState({
        name: "",
        key: "",
        fields: [
            {
                label: "",
                name: "",
                type: ""
            }
        ]
    })

    useEffect(() => {
        if (opened) {
            if (Object.keys(opened).length == 0) {
                let newData = {}
                for (let field of resource.fields) {
                    if (field.type == "switch") {
                        newData[field?.name] = true
                    } else
                        newData[field?.name] = ""
                }

                setData({
                    _id: uuid(),
                    ...newData
                })
                setIsNew(true)
            } else {
                setData(JSON.parse(JSON.stringify(opened)))
                setIsNew(false)
            }
        } else {
            setData({})
        }
    }, [opened])

    const close = () => {
        setOpened(() => null)
    }

    const submit = async () => {
        try {
            startLoading()
            // console.log(data)
            // return

            // console.log("submit", {
            //     resource
            // })

            let items = resource?.type == "collection" ? [] : {}

            try {
                const result = await getResource(resource.key, resource?.type == "collection" ? "items" : undefined)
                console.log(result)

                items = resource?.type == "collection" ? result?.items : result
            } catch (error) {
                if (typeof error == "string") {
                    error = JSON.parse(error)
                    if (error?.message && typeof error.message == "string")
                        error.message = JSON.parse(error.message)
                }

                if (error?.message?.reason?.code == 67) {
                    items = resource?.type == "collection" ? [] : {}
                } else
                    throw error
            }

            let newItems = resource?.type == "collection" ? [...items] : { ...items }

            if (resource?.type == "collection") {
                let itemsIndex = newItems.findIndex(item => item._id == data._id)

                if (itemsIndex >= 0) {
                    newItems[itemsIndex] = data
                } else {
                    newItems.push(data)
                }
            } else {
                newItems = {
                    ...newItems,
                    ...data
                }
            }

            console.log({
                data,
                items,
                newItems
            })

            const result = await IframeMessageProxy.sendMessage({
                action: IMPContainer.Actions.SEND_COMMAND,
                content: {
                    command: {
                        method: IMPContainer.CommandMethods.SET,
                        uri: `/resources/${resource.key}`,
                        type: "application/json",
                        resource: resource?.type == "collection" ? { items: newItems } : newItems
                    },
                    // destination: IMPContainer.Destinations.BLIP_SERVICE
                }
            });

            setItems(newItems)
            close()
        } catch (error) {
            showToast({
                type: BlipPortalToastTypes.DANGER,
                message: error?.message || "Ocorreu um erro"
            });
        } finally {
            stopLoading()
        }
    }

    const setValue = (key, value) => {
        setData(data => {
            data[key] = value
            return { ...data }
        })
    }

    return (
        <bds-modal open={opened != null} close-button="false" size="dynamic">
            <div className="modal-resources">
                <div className="modal-body">
                    {
                        (resource?.type == "collection" ?
                            resource?.fields :
                            Object.keys(data).length > 0 ?
                                [resource?.fields.find(field => field?.name == Object.keys(data)?.[0])] :
                                []
                        )
                            .map((field, index) =>
                                <FieldItem
                                    data={data}
                                    setData={setData}
                                    index={index}
                                    field={field}
                                    setValue={setValue}
                                    isNew={isNew}
                                />
                            )}
                </div>

                {/* {JSON.stringify(data)} */}

                {/* <bds-modal-action> */}
                <div className="flex justify-end" style={{ width: "100%", zIndex: 0 }}>
                    <bds-button variant="secondary" onClick={close}>Cancelar</bds-button>
                    <bds-button onClick={submit}>Pronto</bds-button>
                </div>
                {/* </bds-modal-action> */}
            </div>
        </bds-modal>
    )
}